import {laveusesConstants} from './laveuses.constants';
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {
    laveuses: null,
    laveuse: null,
    context: null,
    contextLoading: false,
    contextError: null,
    telematics: {},
    loading: false, error: null
}

export function laveuses(state = initialState, action) {
    switch (action.type) {
        case laveusesConstants.LAVEUSES_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case laveusesConstants.LAVEUSES_FETCH_SUCCESS:
            return {
                ...state,
                laveuses: action.laveuses,
                laveuse: null,
                loading: false,
                error: null
            };
        case laveusesConstants.LAVEUSES_FETCH_ONE_REQUEST:
            return {
                ...state,
                laveuse: null,
                loading: true,
                error: null
            };
        case laveusesConstants.LAVEUSES_FETCH_ONE_SUCCESS:
            return {
                ...state,
                laveuse: action.laveuse,
                laveuses: null,
                loading: false,
                error: null
            };
        case laveusesConstants.LAVEUSES_FETCH_ONE_FAILURE:
            return {
                ...state,
                laveuse: null,
                loading: false,
                error: action.error
            };
        case laveusesConstants.LAVEUSES_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case laveusesConstants.LAVEUSES_DELETE_SUCCESS:
        case laveusesConstants.LAVEUSES_CREATE_SUCCESS:
        case laveusesConstants.LAVEUSES_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                laveuses: null,
                laveuse: null
            };
        case laveusesConstants.LAVEUSES_FETCH_FAILURE:
        case laveusesConstants.LAVEUSES_CREATE_FAILURE:
        case laveusesConstants.LAVEUSES_UPDATE_FAILURE:
        case laveusesConstants.LAVEUSES_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case laveusesConstants.FETCH_LAVEUSE_CONTEXT_REQUEST:
            return { ...state, contextLoading: true, contextError: null };

        case laveusesConstants.FETCH_LAVEUSE_CONTEXT_SUCCESS:
            return { ...state, contextLoading: false, context: action.data };

        case laveusesConstants.FETCH_LAVEUSE_CONTEXT_FAILURE:
            return { ...state, contextLoading: false, contextError: action.error };

        case laveusesConstants.LAVEUSE_TELEMATICS_FETCH_SUCCESS:
            return {
                ...state,
                telematics: {
                    ...state.telematics,
                    [action.payload.id]: action.payload.data
                }
            };

        case laveusesConstants.LAVEUSE_TELEMATICS_BULK_FETCH_SUCCESS:
            return {
                ...state,
                telematics: {
                    ...state.telematics,
                    ...action.data
                }
            };

        case laveusesConstants.LAVEUSES_CLEAR_REQUEST:
            return {
                ...initialState
            }
        case authenticationConstants.LOGOUT:
            return {
                initialState
            }
        default:
            return state
    }
}
